"use strict";

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

var _reducer = _interopRequireDefault(require("./store/reducer"));

var _actions = require("./store/actions");

var _selectors = require("./store/selectors");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function getInitState(persistKey) {
  var persistedValues = {};

  try {
    persistedValues = JSON.parse(localStorage.getItem(persistKey)) || {};
  } catch (error) {
    console.warn(error);
  }

  return persistedValues;
}

var Provider = function Provider(_ref) {
  var children = _ref.children,
      _ref$persistKey = _ref.persistKey,
      persistKey = _ref$persistKey === void 0 ? 'mui_filter' : _ref$persistKey;

  var _useReducer = (0, _react.useReducer)(_reducer.default, getInitState(persistKey)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  (0, _react.useEffect)(function () {
    try {
      localStorage.setItem(persistKey, JSON.stringify(state));
    } catch (error) {
      console.warn(error);
    }
  }, [state, persistKey]);
  var props = {
    openFilter: function openFilter(name) {
      return dispatch((0, _actions.openFilter)(name));
    },
    closeFilter: function closeFilter(name) {
      return dispatch((0, _actions.closeFilter)(name));
    },
    clearFilter: function clearFilter(name) {
      return dispatch((0, _actions.clearFilter)(name));
    },
    setSearch: function setSearch(name, search) {
      return dispatch((0, _actions.setSearch)(name, search));
    },
    setFilterSortField: function setFilterSortField(name, sortField) {
      return dispatch((0, _actions.setFilterSortField)(name, sortField));
    },
    setFilterSortOrientation: function setFilterSortOrientation(name, sortOrientation) {
      return dispatch((0, _actions.setFilterSortOrientation)(name, sortOrientation));
    },
    addFilterQuery: function addFilterQuery(name, query) {
      return dispatch((0, _actions.addFilterQuery)(name, query));
    },
    removeFilterQuery: function removeFilterQuery(name, index) {
      return dispatch((0, _actions.removeFilterQuery)(name, index));
    },
    editFilterQuery: function editFilterQuery(name, index, query) {
      return dispatch((0, _actions.editFilterQuery)(name, index, query));
    },
    getList: function getList(name, list, fields) {
      return (0, _selectors.getList)(state[name], list, fields);
    },
    isFilterOpen: function isFilterOpen(name) {
      return state[name] ? !!state[name].isOpen : false;
    },
    getFilterQueries: function getFilterQueries(name) {
      return state[name] && state[name].queries ? state[name].queries : [];
    },
    getFilter: function getFilter(name) {
      return state[name] ? state[name] : {};
    },
    getField: function getField(fieldName, fields) {
      return (0, _selectors.getField)(fieldName, fields);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Context.default.Provider, {
    value: _extends({}, props)
  }, children);
};

Provider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.any
} : {};
var _default = Provider;
exports.default = _default;
module.exports = exports.default;